import BookIndex from "components/shared/book/list";
import { Transition } from "components/shared/column";
import SharedReactTable from "components/shared/reactTable";
import { RecipientWithOrgOption, RecipientWithOrgValueContainer } from "components/shared/select";
import { dateTimeToView } from "helpers/date";
import { ratings } from "helpers/enums";
import { paths } from "helpers/paths";
import { DateRangeColumnFilter, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { enumLabel } from "helpers/system";
import React from "react";
import { Link } from "react-router-dom";
import { getOrganizationNames } from "sources/admin";
import { list } from "sources/books/admin/drivers";

class MobileAppRatings extends BookIndex {
    componentWillUnmount() {
        this.props.clearParams();
    }

    get tableColumns() {
        return [
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Дата создания",
                accessor: "createdAt",
                filterable: true,
                Filter: DateRangeColumnFilter,
                filterType: "dateTimeRange",
                Cell: ({ value }) => dateTimeToView(value),
                CSVExport: ({ value }) => dateTimeToView(value),
            },
            {
                Header: "Хост",
                accessor: "host",
                filterable: true,
            },
            {
                Header: "Организация",
                accessor: "organizationName",
                id: "organizationId",
                sortable: true,
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: getOrganizationNames,
                            inputProps: { name: "organizationId" },
                            propName: "name",
                        }}
                    />
                ),
                Cell: ({
                    row: {
                        original: { organizationName, organizationId },
                    },
                }) =>
                    organizationName &&
                    organizationId && <Link to={paths.adminOrganizationsShow(organizationId)}>{organizationName}</Link>,
            },
            {
                Header: "Водитель",
                accessor: "fullName",
                id: "driverId",
                sortable: true,
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: list,
                            inputProps: { name: "driverId" },
                            propName: "fullName",
                            components: {
                                Option: (props) => (
                                    <RecipientWithOrgOption
                                        {...props}
                                        data={{
                                            ...props.data,
                                            option: {
                                                ...props.data.option,
                                                fullNameOrEmail: props.data.option.fullName,
                                            },
                                        }}
                                    />
                                ),
                                ValueContainer: RecipientWithOrgValueContainer,
                            },
                        }}
                    />
                ),
            },
            {
                Header: "Номер телефона",
                accessor: "phoneNumber",
                sortable: true,
                filterable: true,
            },
            {
                Header: "Оценка",
                accessor: "rating",
                filterable: true,
                filterType: "enum",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "status" },
                            options: ratings,
                        }}
                    />
                ),
                Cell: ({ value }) => enumLabel(ratings, value),
                CSVExport: ({ value }) => enumLabel(ratings, value),
            },
            {
                Header: "Комментарий",
                accessor: "comment",
                filterable: true,
            },
        ];
    }

    renderHead = () => {
        return (
            <div className="book-list__head">
                <div className="book-list__head-close close close--sm" onClick={this.close} />
                <div className="book-list__head-title">Оценки приложения водителями</div>
                <div className="btn-toolbar" />
            </div>
        );
    };

    renderListComponent = () => {
        return <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
    };

    render() {
        return (
            <div className="page-content">
                <Transition dir="full">
                    <div className="page-book__list book-list list book-list--nofilter">
                        {this.renderHead()}
                        {this.renderListComponent()}
                    </div>
                </Transition>
            </div>
        );
    }
}

export default tableContainer(MobileAppRatings, "mobile-app-ratings");
